/**
 * MID Racing spec table — P.C.D. + diameter (inch) filters.
 * Also handles Face Design pill-switched image viewer.
 * Expects markup from mid-racing-spec-table-sample.html (data attributes on rows).
 */
(function () {
  function applyRowStriping(wrap) {
    var rows = wrap.querySelectorAll(
      "tbody tr.midwheel-spec-data-row:not(.midwheel-spec-row--hidden)"
    );
    rows.forEach(function (row, i) {
      row.classList.toggle("midwheel-spec-row-alt", i % 2 === 1);
    });
  }

  function filterRows(wrap) {
    var d = wrap.getAttribute("data-midwheel-filter-diameter") || "all";
    var p = wrap.getAttribute("data-midwheel-filter-pcd") || "all";
    wrap.querySelectorAll("tbody tr.midwheel-spec-data-row").forEach(function (row) {
      var okD = d === "all" || row.getAttribute("data-midwheel-diameter") === d;
      var okP = p === "all" || row.getAttribute("data-midwheel-pcd") === p;
      row.classList.toggle("midwheel-spec-row--hidden", !(okD && okP));
    });
    applyRowStriping(wrap);
  }

  function setActivePills(wrap) {
    var d = wrap.getAttribute("data-midwheel-filter-diameter") || "all";
    var p = wrap.getAttribute("data-midwheel-filter-pcd") || "all";
    wrap.querySelectorAll("[data-midwheel-filter-diameter]").forEach(function (btn) {
      var v = btn.getAttribute("data-midwheel-filter-diameter");
      btn.classList.toggle("midwheel-spec-pill--active", v === d);
    });
    wrap.querySelectorAll("[data-midwheel-filter-pcd]").forEach(function (btn) {
      var v = btn.getAttribute("data-midwheel-filter-pcd");
      btn.classList.toggle("midwheel-spec-pill--active", v === p);
    });
  }

  function initWrap(wrap) {
    if (wrap._midwheelInit) return;
    wrap._midwheelInit = true;

    if (!wrap.getAttribute("data-midwheel-filter-diameter")) {
      wrap.setAttribute("data-midwheel-filter-diameter", "all");
    }
    if (!wrap.getAttribute("data-midwheel-filter-pcd")) {
      wrap.setAttribute("data-midwheel-filter-pcd", "all");
    }

    wrap.addEventListener("click", function (e) {
      var t = e.target.closest("[data-midwheel-filter-diameter], [data-midwheel-filter-pcd]");
      if (!t || !wrap.contains(t)) return;
      e.preventDefault();
      if (t.hasAttribute("data-midwheel-filter-diameter")) {
        wrap.setAttribute("data-midwheel-filter-diameter", t.getAttribute("data-midwheel-filter-diameter"));
      }
      if (t.hasAttribute("data-midwheel-filter-pcd")) {
        wrap.setAttribute("data-midwheel-filter-pcd", t.getAttribute("data-midwheel-filter-pcd"));
      }
      setActivePills(wrap);
      filterRows(wrap);
    });

    setActivePills(wrap);
    filterRows(wrap);
  }

  function initFaceDesign(wrap) {
    if (wrap._midwheelFaceInit) return;
    wrap._midwheelFaceInit = true;

    wrap.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-midwheel-face-idx]");
      if (!btn || btn.tagName !== "BUTTON") return;
      e.preventDefault();
      var idx = btn.getAttribute("data-midwheel-face-idx");
      wrap.querySelectorAll(".midwheel-spec-pill").forEach(function (p) {
        p.classList.toggle("midwheel-spec-pill--active",
          p.getAttribute("data-midwheel-face-idx") === idx);
      });
      wrap.querySelectorAll(".midwheel-face-img").forEach(function (img) {
        img.classList.toggle("midwheel-face-img--hidden",
          img.getAttribute("data-midwheel-face-idx") !== idx);
      });
    });
  }

  function boot() {
    document.querySelectorAll(".midwheel-spec-table-wrap[data-midwheel-spec]").forEach(initWrap);
    document.querySelectorAll(".midwheel-spec-table-wrap[data-midwheel-face]").forEach(initFaceDesign);
  }

  boot();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  }

  var observer = new MutationObserver(function () { boot(); });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
